<template>
  <div class="roc-date-picker-year-month">
    <b-form-select
      v-model="select.year"
      :options="options.year"
      @change="changeDate" />

    <b-form-select
      v-model="select.month"
      :options="options.month"
      @change="changeDate" />
  </div>
</template>

<script>
export default {
  name: "RocDatePickerYearMonth",
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      type: String | Number,
      required: false
    },
    format: {
      type: String,
      required: false,
      default: 'yyymm'
    },
  },
  data () {
    return {
      options: {
        year: [],
        month: [
          { value: '01', text: '1月' },
          { value: '02', text: '2月' },
          { value: '03', text: '3月' },
          { value: '04', text: '4月' },
          { value: '05', text: '5月' },
          { value: '06', text: '6月' },
          { value: '07', text: '7月' },
          { value: '08', text: '8月' },
          { value: '09', text: '9月' },
          { value: '10', text: '10月' },
          { value: '11', text: '11月' },
          { value: '12', text: '12月' },
        ],
      },
      select: {
        year: '',
        month: ''
      }
    }
  },
  watch: {
    values: {
      handler(newValue, oldValue) {
        this.initYearMonthHandler(newValue);
      },
      immediate: true
    }
  },
  mounted() {
    this.generateYearArray();
  },
  methods: {
    // 產生年份陣列資料
    generateYearArray() {
      const currentYear = new Date().getFullYear(); // Get current year in AD
      const startYearROC = 105; // Start year in ROC
      const endYearROC = currentYear - 1911; // End year in ROC

      const yearArray = Array.from({ length: currentYear - (startYearROC + 1911) + 1}, (num, index) => {
        const rocYear = endYearROC - index;

        return {
          value: rocYear,
          text: `${rocYear}年`,
        };
      });

      this.options.year = yearArray;
    },
    // 初始值年月處理
    initYearMonthHandler(date) {
      // this.select.year = date.substr(0, 3);
      // this.select.month = date.substr(3, 2);

      const formatRegex = /(\d{3})(\D*)(\d{2})/;
      let matches = formatRegex.exec(this.values);

      if (matches && matches.length === 4) {
        this.select.year = matches[1];
        this.select.month = matches[3];
      } else {
        this.select.year = '';
        this.select.month = '';
      }
    },
    // 年或月 日期改變時觸發
    changeDate() {
      if (this.select.year && this.select.month) {
        let year_month_day;
        const formatRegex = /yyy|mm/g; // 用于匹配'yyyy'、'mm'

        year_month_day = this.format.replace(formatRegex, (match) => {
          switch (match) {
            case 'yyy':
              return this.select.year; // 替换年份
            case 'mm':
              return this.select.month; // 替换月份
            default:
              return match; // 默认情况下保持原样
          }
        });

        this.$emit('change', year_month_day);
        this.$emit('dateChange');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.roc-date-picker-year-month {
  display: flex;
  align-content: center;
  column-gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/RocDatePickerYearMonth.vue